var map = {
	"./product_stkr_best.png": "d0b5",
	"./product_stkr_event.png": "c149",
	"./product_stkr_heritage.png": "6a84",
	"./product_stkr_promotion.png": "2968",
	"./product_stkr_sale.png": "9b9e",
	"./product_stkr_signature.png": "2add"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2aeb9";